import { defineComponent, ref } from '@vue/composition-api';
import { BfButton } from 'components/Butterfly';
import Modal from 'src/components/project/analysis/results/Modal.vue';
const ExportModal = defineComponent({
    components: {
        BfButton,
        Modal,
    },
    setup() {
        const visible = ref(false);
        const loading = ref(false);
        const resolveFunc = ref();
        const fieldList = ref([]);
        const selectedValues = ref({});
        const open = (fields) => {
            loading.value = false;
            visible.value = true;
            fieldList.value = fields;
            selectedValues.value = fields.reduce((acc, field) => {
                acc[field.label] = field.values;
                return acc;
            }, {});
            return new Promise((resolve) => {
                resolveFunc.value = resolve;
            });
        };
        const close = () => {
            visible.value = false;
        };
        const submit = () => {
            loading.value = true;
            resolveFunc.value?.(selectedValues.value);
        };
        const updateSelection = (label, value) => {
            selectedValues.value = {
                ...selectedValues.value,
                [label]: value,
            };
        };
        return {
            visible,
            open,
            close,
            submit,
            fieldList,
            updateSelection,
            selectedValues,
            loading,
        };
    },
});
export default ExportModal;
